<article class="info-card">
  <header class="info-card__header">
    <h3 class="info-card__title">{{ title }}</h3>

    @if (icon) {
      <span
        class="info-card__icon"
        [attr.aria-label]="iconAriaLabel"
        [innerHTML]="icon">
      </span>
    }
  </header>

  <div class="info-card__content">
    <ng-content></ng-content>
  </div>
</article>
